/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { UtCategoryLinkComponent } from './category-link.component';

// Not standalone, like the other community components: the link's uiSref comes from UIRouter's module.
@NgModule({
  imports: [UIRouterModule],
  declarations: [UtCategoryLinkComponent],
  exports: [UtCategoryLinkComponent],
})
class UtCategoryLinkModule {}

export { UtCategoryLinkModule };
